// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"144":"0d6d57ae","166":"19590e9a","288":"8e14f2e2","357":"8e14f2e2","642":"19590e9a"}[chunkId] + ".css";
};